import { LAYOUT_OBJECT_DEFAULT_TEXT_INDENT } from '../../constants';

export const getLayoutButtonIndent = (value: unknown): number => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    return LAYOUT_OBJECT_DEFAULT_TEXT_INDENT;
  }

  return value;
};
